import { Alert, Button, Chip, CircularProgress, Container, IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useCallback, useEffect, useState } from "react";
import { IMPORT_URL, TICKET_SYSTEM_BASE_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import AppTableView from "../AppTableView";
import { useAlert } from "../alerts/AlertContext";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ImportTableConfigDialog from "./ImportTableConfigDialog";
import GenericCsvImportDialog from "./GenericCsvImportDialog";

const statusColors = {
  open: "#007BFF",
  "in-progress": "#FD7E14",
  hold: "#FFC107",
  resolved: "#20C997",
  closed: "#6C757D",
};

function GenericCsvImport() {
  const [editData, setEditData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const showAlert = useAlert();
  const [open, setOpen] = useState(false);

  const getTablesData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await AxiosInstance.get(`${IMPORT_URL}/tables`);
      setEditData(response.data || []);
    } catch (error) {
      console.error("Error fetching api data:", error);
      setError("Failed to load api data. Please try again.");
      // showAlert("Failed to load statuses", "error");
    } finally {
      setLoading(false);
    }
  }, [showAlert]);

  useEffect(() => {
    getTablesData();
  }, [getTablesData]);

  const handleClose = () => {
    setOpen(false);
  };

  const columns = [
    {
      field: "tableCode",
      flex: 1,
      headerName: "Table Code",
      renderCell: (params) => params.value,
    },
    {
      field: "tableName",
      flex: 1,
      headerName: "Table Name",
      renderCell: (params) => params.value,
    },
    {
      field: "displayName",
      flex: 1,
      headerName: "Display Name",
      renderCell: (params) => params.value,
    },
    {
      field: "description",
      flex: 1,
      headerName: "Description",
      renderCell: (params) => params.value,
    },
    {
      field: "enabled",
      flex: 1,
      headerName: "Enabled",
      renderCell: (params) => (params.value ? "Yes" : "No"),
    },
    {
      field: "allowInsert",
      flex: 1,
      headerName: "Allow Insert",
      renderCell: (params) => (params.value ? "Yes" : "No"),
    },
    {
      field: "allowUpdate",
      flex: 1,
      headerName: "Allow Update",
      renderCell: (params) => (params.value ? "Yes" : "No"),
    },
    {
      field: "action",
      flex: 1,
      headerName: "Actions",
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <GenericCsvImportDialog
            tableId={params.row.id}
            tableName="Edit"
            variant="link"
          />
        </Box>
      ),
    }

  ];

  //if error content
  if (error) {
    return (
      <Container>
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={getTablesData}>
              Retry
            </Button>
          }
          sx={{ borderRadius: 2 }}
        >
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Box
      sx={{
        borderRadius: "8px",
        overflow: "hidden",
        p: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      {/* loading or content */}
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <AppTableView rows={editData} cols={columns} initialPageSize={5} />
      )}
    </Box>
  );
}

export default GenericCsvImport;
